<template>
	<div class="pagination-box text-center">
		<ul class="pagination">
			<li class="none">
				<a @click="pageChanged(prevPage)" aria-label="Previous">
					<img src="images/prev.png" alt="이전">
				</a>
			</li>
			<li v-for="page in Array.from('x'.repeat(lastPgno-firstPgno+1),(_,i)=>firstPgno+i)" v-bind:key="page" v-bind:class="{active:currentPage==page}"><a @click="pageChanged(page)">{{ page }}</a></li>
			<li class="none">
				<a @click="pageChanged(nextPage)" aria-label="Next">
					<img src="images/next.png" alt="">
				</a>
			</li>
		</ul>
	</div>
</template>

<script>
let numbersPerPage = 5; // 한 페이지에 노출할 페이지넘버 갯수

export default {
	// 컴포넌트 명
	name: "CtrlPagination",

	// 이 컴포넌트 내부에서 사용 할 계산된 속성값
	computed: {
		firstPage: function()
		{
			return 1;
		},
		lastPage: function()
		{
			return Math.ceil(this.totalCount/this.pageSize)?Math.ceil(this.totalCount/this.pageSize):1;
		},
		nextPage: function()
		{
			let firstPgno = 0, lastPgno = 0;
			let prevPage = 0, nextPage = 0;
			if(this.currentPage % numbersPerPage == 0)
			{
				firstPgno = this.currentPage - (numbersPerPage-1);
				lastPgno = this.currentPage;
			}
			else
			{
				firstPgno = this.currentPage - (this.currentPage%numbersPerPage-1);
				lastPgno = firstPgno + (numbersPerPage-1);
			}
			if(lastPgno > this.lastPage) lastPgno = this.lastPage;
			prevPage = firstPgno - 1;
			nextPage = lastPgno + 1;
			if(prevPage < 1) prevPage = 1;
			if(nextPage > this.lastPage) nextPage = this.lastPage;
			return nextPage;
		},
		prevPage: function()
		{
			let firstPgno = 0, lastPgno = 0;
			let prevPage = 0, nextPage = 0;
			if(this.currentPage % numbersPerPage == 0)
			{
				firstPgno = this.currentPage - (numbersPerPage-1);
				lastPgno = this.currentPage;
			}
			else
			{
				firstPgno = this.currentPage - (this.currentPage%numbersPerPage-1);
				lastPgno = firstPgno + (numbersPerPage-1);
			}
			if(lastPgno > this.lastPage) lastPgno = this.lastPage;
			prevPage = firstPgno - 1;
			nextPage = lastPgno + 1;
			if(prevPage < 1) prevPage = 1;
			if(nextPage > this.lastPage) nextPage = this.lastPage;
			return prevPage;
		},
		firstPgno: function()
		{
			let firstPgno = 0, lastPgno = 0;
			let prevPage = 0, nextPage = 0;
			if(this.currentPage % numbersPerPage == 0)
			{
				firstPgno = this.currentPage - (numbersPerPage-1);
				lastPgno = this.currentPage;
			}
			else
			{
				firstPgno = this.currentPage - (this.currentPage%numbersPerPage-1);
				lastPgno = firstPgno + (numbersPerPage-1);
			}
			if(lastPgno > this.lastPage) lastPgno = this.lastPage;
			prevPage = firstPgno - 1;
			nextPage = lastPgno + 1;
			if(prevPage < 1) prevPage = 1;
			if(nextPage > this.lastPage) nextPage = this.lastPage;
			return firstPgno;
		},
		lastPgno: function()
		{
			let firstPgno = 0, lastPgno = 0;
			let prevPage = 0, nextPage = 0;
			if(this.currentPage % numbersPerPage == 0)
			{
				firstPgno = this.currentPage - (numbersPerPage-1);
				lastPgno = this.currentPage;
			}
			else
			{
				firstPgno = this.currentPage - (this.currentPage%numbersPerPage-1);
				lastPgno = firstPgno + (numbersPerPage-1);
			}
			if(lastPgno > this.lastPage) lastPgno = this.lastPage;
			prevPage = firstPgno - 1;
			nextPage = lastPgno + 1;
			if(prevPage < 1) prevPage = 1;
			if(nextPage > this.lastPage) nextPage = this.lastPage;
			return lastPgno;
		}
	},

	// 부모컴포넌트로부터 받아들일 데이터
	props: {
		currentPage: Number,
		pageSize: Number,
		totalCount: Number
	},

	// 이 컴포넌트에서 사용할 기능
	methods: {
		pageChanged: function(page)
		{
			this.$emit("pageChanged", page);
		}
	}
};
</script>

<style scoped>
a:hover { cursor:pointer; }
</style>